import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"info\"><path fill-rule=\"evenodd\" stroke=\"#010101\" stroke-width=\"0\" fill=\"#2D6CB5\" d=\"M3 0h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z\" /><path fill-rule=\"evenodd\" stroke=\"#010101\" stroke-width=\"0\" fill=\"#FFF\" d=\"M7 7h2v6H7V7zM7 3h2v2H7V3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol